import React, { useState , useRef, useEffect} from 'react';

import styles from './searchbarDash.module.css';
import Searchbar from './Searchbar/Searchbar.jsx';

import axios from 'axios';
import dayjs from 'dayjs';

import { MdPushPin } from "react-icons/md";
      
import { useGlobalState } from '../../../global_state_components/GlobalStateProvider.jsx';

import { MdOutlinePushPin } from "react-icons/md";

import { Calendar as SmallCalendar } from 'react-calendar';  // Importing as small calendar to avoid conflict and confusion with the main calendar.

import 'react-calendar/dist/Calendar.css'; // Import the calendar styles





function SearchbarDash() {
  const {subject, calendarMonthAndYear, smallCalendarSelectedDate, setSmallCalendarSelectedDate, setSubjectFn, pinnedSubjects, permanentSubjects, userAddedSubjects, subjectSearchbarInputRef} = useGlobalState();


  



  //-----Display small calendar or not  (Down)----------------

  const [displaySmallCalendar, setDisplaySmallCalendar] = useState(false);
  function handleDisplaySmallCalendar(){
    if (displaySmallCalendar===false){
      setDisplaySmallCalendar(true);
    }else if (displaySmallCalendar===true){
      setDisplaySmallCalendar(false);
    }
  }

  //---
  // After adding the below it seems like it is taking too much time to load when you run "npm start".
  const displaySmallCalendarRef = useRef(null);
  const smallCalendarRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (displaySmallCalendarRef.current && !displaySmallCalendarRef.current.contains(event.target) && smallCalendarRef.current && !smallCalendarRef.current.contains(event.target)) {
        // Clicked outside the component
        //console.log('Clicked outside!');
        setDisplaySmallCalendar(false);
      }
    }

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);








  const handleDateChange = (newDate) => {
    //setSmallCalendarSelectedDate(newDate);
    //setSmallCalendarSelectedDate(Math.floor(newDate.getTime() / 1000));   // Unix timestamp in seconds
    //setSmallCalendarSelectedDate(newDate.getTime());   // Unix timestamp in milli seconds   //Actually the newDate parameter just gives selected date so it is not the exact time in millisecond.
    //console.log("nnnnnnnnnnnnnewDate : "+newDate);
    setSmallCalendarSelectedDate(newDate);
  };








  //update the bottom component as 3 components.
  return(
    <div className={styles.searchbar_dash_main_div}>

      <div className={styles.month_and_year_p_tag_div}>
        <p ref={displaySmallCalendarRef} onClick={handleDisplaySmallCalendar} className={styles.month_and_year_p_tag}>{calendarMonthAndYear}</p>
      </div>
      
      {displaySmallCalendar && (
        <div ref={smallCalendarRef} style={{position: 'absolute', top: '25%', left: '22%' ,zIndex: 5 }}>
          {/*<Calendar minDate={new Date()} onChange={handleDateChange} value={new Date(smallCalendarSelectedDate)}/>*/}
          <SmallCalendar minDate={new Date()} onChange={handleDateChange} value={smallCalendarSelectedDate}/>
        </div>
      )}

      {/* <Searchbar/> */}
      <Searchbar marginRightProp={pinnedSubjects.includes(subject) ? '30%' : ''} />    {/* marginRight is given when unpinnned_side_subject is not there. So that the search bar stays centralised. */}

      {(!pinnedSubjects.includes(subject))&&(
        <div className={styles.unpinned_side_subject}>
          {/*<p>{!pinnedSubjects.includes(subject)&&subject}</p>*/}
          {/*(!pinnedSubjects.includes(subject))&& <p>{subject}</p> */}
          <p>{subject}</p>
        </div>
      )}

    </div>
  )

}


export default SearchbarDash;

// Testing the new keyboard for it's convenience. Let's see if it's good or not. 












